import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Register from '../views/Register.vue'
import Repwd from '../views/Repwd.vue'
import PapInt from '../views/PapInt.vue'
import Home from '../views/Home.vue'
import hometal from '../views/Homeson/hometal.vue'
import Paperfm from '../views/Homeson/Paperfm.vue'
import homePage from '../views/HomPpage/homePage.vue'
import Agreement from '../views/Agreement/agreement.vue'
import Agreements from '../views/Agreement/agreementTwo.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'login'
  },
  // {
  //     path: '/homePage',
  //     name: 'homePage',
  //     component: homePage
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/Repwd',
    name: 'Repwd',
    component: Repwd
  },

  {
    path: '/PapInt',
    name: 'PapInt',
    component: PapInt
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: Agreement
  },
  {
    path: '/agreements',
    name: 'agreements',
    component: Agreements
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    redirect: '/Home/tal',
    children: [
      {
        path: '/Home/tal',
        name: 'tal',
        component: hometal
      },
      {
        path: '/Home/Paperfm',
        name: 'Paperfm',
        component: Paperfm
      }
    ]
  }

  // {
  //     path: '/about',
  //     name: 'About',
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () =>
  //         import ( /* webpackChunkName: "about" */ 'import')
  // }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
